import { render, staticRenderFns } from "./ReferralMenu.vue?vue&type=template&id=6b2e46ba"
import script from "./ReferralMenu.vue?vue&type=script&lang=js"
export * from "./ReferralMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports